export const tabOptions = {
  person: {
    en: 'Person',
    ar: 'شخص'
  },
  colour: {
    en: 'Colour',
    ar: 'لون'
  },
  haircut: {
    en: 'Hairstyle',
    ar: 'تسريحة الشعر'
  },
  facial: {
    en: 'Face',
    ar: 'وجه'
  },
  top: {
    en: 'Top/dress',
    ar: 'اللبس العلوي'
  },
  bottom: {
    en: 'Bottom',
    ar: 'السفلي'
  },
  kader: {
    en: 'Colour',
    ar: 'لون'
  }
};

export const labelContent = {
  en: 'Surprise me',
  ar: 'فاجئني!'
};
